import { render, staticRenderFns } from "./workflow-components-wrapper.vue?vue&type=template&id=0b81591a&scoped=true&"
import script from "./workflow-components-wrapper.vue?vue&type=script&lang=ts&"
export * from "./workflow-components-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./workflow-components-wrapper.vue?vue&type=style&index=0&id=0b81591a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b81591a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDivider,VForm,VIcon})
